module.exports = __webpack_public_path__ + "static/media/CLUB-10.53cc29b8.svg";